/**
* @file Marquee main cards
*/

import Marquee from 'integration-common-files/src/js/02-molecules/marquee';

export default function loadMarquee(){
  // Marquee
  const marquee1 = document.querySelector('#marquee-energy');
  if(marquee1) {
    new Marquee({
      selector: '#marquee-energy',
    })
  }

  // Marquee
  const marquee2 = document.querySelector('#marquee-telecom');
  if(marquee2) {
    new Marquee({
      selector: '#marquee-telecom',
    })
  }
};

